import React, {useState} from 'react'
import formatDistanceToNow from 'date-fns/formatDistanceToNow'
// componets
import Avatar from '../../components/avator/Avatar'

// firebase
import { timestamp } from '../../Firebase/Config'

// Hooks
import { useAuthContext } from '../../Hooks/useAuthContext'
import { useFireStore } from '../../Hooks/useFireStore'


export default function ProjectComments({ project }) {
    const [comment, setComment] = useState('')

    const { user } = useAuthContext()
    const { updateDocument, response} = useFireStore('projects')

    const handleSubmit = async (e) => {
        e.preventDefault()

        // comment object
        const commentToAdd = {
            displayName: user.displayName,
            photoURL: user.photoURL,
            content: comment,
            createdAt: timestamp.fromDate(new Date()),
            id: Math.random()
        }


        await updateDocument(project.id, {
            comments: [...project.comments, commentToAdd ]
        })
        if(!response.error){
            setComment('')
        }
    }

    return (
        <div className='project-comments'>
            <h4>Project Comments</h4>
            
            <form className='add-comments' onSubmit={handleSubmit}>
                <label >
                    <span>Add New Comment</span>
                    <textarea  
                        value={comment} 
                        onChange={(e) => setComment(e.target.value)} 
                        required 
                    ></textarea>
                </label>
                <button className='btn'>Add Comment</button>
            </form>

            <ul>
                {project.comments.length > 0 &&  project.comments.map((comment) => (
                    <li key={comment.id}>
                        <div className="comment-author">
                            <Avatar image={comment.photoURL}/>
                            <p>{comment.displayName}</p>
                        </div>
                        <div className="comment-date">
                            <p>Creadted: { formatDistanceToNow( comment.createdAt.toDate(), { addSuffix: true } )}</p>
                        </div>
                        <div className="comment-content">
                            <p>{comment.content}</p>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    )
}
